import { Trigger } from '@radix-ui/react-hover-card';
import { forwardRef } from 'react';

export const HoverCardTrigger = forwardRef<
  HTMLAnchorElement,
  React.ComponentPropsWithoutRef<typeof Trigger>
>((props, ref) => {
  return <Trigger ref={ref} {...props} />;
});
